'use client'

import { ReactNode } from 'react'
import ErrorPageComponent from '@/app/_components/ErrorPage/ErrorPageComponent'
import Error from 'next/error'

/**
 * App-wide last-resort error boundary.
 *
 * Handles errors thrown by the root layout (`app/layout.tsx`) and acts as the final fallback
 * when no other boundary catches an error. It replaces the root layout, so it must render its
 * own `<html>`/`<body>`.
 */
const GlobalError = ({ error }: { error: Error }): ReactNode => {
  return (
    <html lang="en">
      <body>
        <ErrorPageComponent error={error} withHeader withFooter />
      </body>
    </html>
  )
}

export default GlobalError
